"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _CornerstoneModal = _interopRequireDefault(require("../CornerstoneModal"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var _default = InnerComponent => class PromiseModal extends _react.Component {
  constructor() {
    super(...arguments);
    _defineProperty(this, "state", {
      visible: false,
      props: {},
      modalProps: {}
    });
    _defineProperty(this, "setModalProps", modalProps => {
      return this.setState({
        modalProps
      });
    });
    _defineProperty(this, "getModalProps", () => {
      const {
        modalProps = {}
      } = this.props;
      return {
        ...modalProps,
        ...this.state.modalProps
      };
    });
    _defineProperty(this, "handleOk", newRecord => {
      this.setState({
        visible: false
      });
      this.resolve(newRecord);
    });
    _defineProperty(this, "handleCancel", e => {
      this.setState({
        visible: false
      });
      this.reject(e);
    });
  }
  open() {
    let props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    let modalProps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    this.setState({
      visible: true,
      props,
      modalProps
    });
    return new Promise((resolve, reject) => {
      this.resolve = resolve;
      this.reject = reject;
    });
  }
  render() {
    const {
      modalProps = {},
      ...rest
    } = this.props;
    const mProps = this.getModalProps();
    return /*#__PURE__*/_react.default.createElement(_CornerstoneModal.default, _extends({
      footer: false
    }, mProps, {
      visible: this.state.visible,
      onCancel: this.handleCancel
    }), this.state.visible && /*#__PURE__*/_react.default.createElement(InnerComponent, _extends({
      ref: ref => this.innerComponent = ref
    }, this.state.props, rest, {
      getModalProps: this.getModalProps,
      setModalProps: this.setModalProps,
      handleSubmit: this.handleOk,
      handleCancel: this.handleCancel,
      onSubmit: this.handleOk,
      onCancel: this.handleCancel,
      onSuccess: this.handleOk,
      onError: this.handleCancel
    })));
  }
};
exports.default = _default;